import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Switch, Alert, Modal } from 'antd';
import classnames from 'classnames';
import { updateRoutingProperties } from 'modules/userrequest';
import styles from 'components/FeatureAuthorisations/FeatureAuthorisations.module.scss';

class FeatureAuthorisations extends Component {
  state = {
    isAuthorized: 0,
  };

  handleModalOk = () => {
    const { isAuthorized } = this.state;
    const {
      feature: { properties: { relatedFeatureId } },
      activity: { filters },
      showModal,
    } = this.props;

    this.props.updateRoutingProperties(
      relatedFeatureId,
      isAuthorized,
      filters,
    );
    showModal();
  }

  handleModalCancel = () => {
    this.props.showModal();
  }

  handleAuthorisationChange = () => {
    this.setState(previousState => ({ isAuthorized: previousState.isAuthorized ? 0 : 1 }));
  }

  render () {
    const { handleModalOk, handleModalCancel, handleAuthorisationChange } = this;
    const { isAuthorized } = this.state;
    const { activity, visible } = this.props;
    const { forbidden, modalSwitch } = styles;

    return (
      <Modal
        title="Modifier les autorisations pour ce parcours"
        visible={visible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        okText="Sauvegarder"
        okType="danger"
      >
        <React.Fragment>
          <p>
            <Switch
              className={classnames({
                [forbidden]: !isAuthorized,
                [modalSwitch]: true,
              })}
              checked={!!isAuthorized}
              onChange={handleAuthorisationChange}
              checkedChildren="Autoriser"
              unCheckedChildren="Refuser"
            />
            &nbsp;ce parcours pour <strong>toutes</strong>
            &nbsp;les <strong>déclarations</strong> de type <strong>{activity.category}</strong>
          </p>
          <Alert
            style={{ marginTop: 10 }}
            type="warning"
            showIcon
            message="Les modifications apportées seront inscrites en base de donnée."
          />
        </React.Fragment>
      </Modal>
    );
  }
}

const DispatchToProps = dispatch =>
  bindActionCreators({
    updateRoutingProperties,
  }, dispatch);

export default connect(null, DispatchToProps)(FeatureAuthorisations);



// WEBPACK FOOTER //
// ./src/components/FeatureAuthorisations/index.js